import { atom } from "jotai";

import type { AgentFilters } from "@repo/utils";

export {
  type AgentFilters,
  type AgentSortOption,
  AGENT_SEARCH_URL_KEYS,
  getAgentSearchParams,
  updateAgentSearchParams,
  readFromAgentSearchParams,
} from "@repo/utils";

export const agentsFiltersAtom = atom<AgentFilters>({
  location: null,
  name: "",
  languageIds: [],
  specialtyIds: [],
  sort: "recommended",
  page: 1,
});
